export default {"src":"/_next/static/media/mustardgreens.795a0dd9.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};